import { AbstractControl } from "@angular/forms";
import { Injectable } from "@angular/core";
import { ComponentSecurityService } from "../../Services/component-security.service";

@Injectable()
export class ComponentSecurityValidators {
  constructor(private service: ComponentSecurityService) {}

  shouldBeUnique(ac: AbstractControl) {
    // ac will hold each of the form controls
    const componentName = ac.get("componentName").value;
    const username = ac.get("user").value;
    const id = ac.get("id").value;

    if (componentName != null && username != null) {
      this.service.checkForDuplicate(componentName, username, id).subscribe(
        (response) => {
          if (response.length > 0)
            ac.get("user").setErrors({ isDuplicate: true });
          else ac.get("user").setErrors(null);
        },
        (error) => {
          ac.get("user").setErrors(null);
        }
      );
    }
  }
}
